import { render, staticRenderFns } from "./ShowModalButton.vue?vue&type=template&id=ec2b0c60&scoped=true&"
import script from "./ShowModalButton.vue?vue&type=script&lang=js&"
export * from "./ShowModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b0c60",
  null
  
)

export default component.exports